import { render, staticRenderFns } from "./discountDialog.vue?vue&type=template&id=54ce5c14&"
import script from "./discountDialog.vue?vue&type=script&lang=ts&"
export * from "./discountDialog.vue?vue&type=script&lang=ts&"
import style0 from "./discountDialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports